/* eslint-disable max-len */
import { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { Generals } from '../../enums/general.names.enum';
import expandButton from '../../Assets/AlertIcon/route.svg';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import { useAtom, useSetAtom, useAtomValue } from 'jotai';
import {
  openKmzBar,
  openUploadKmz,
  kmzNetwork,
  allKmzs,
  regionForkmzNetwork,
  cityForkmzNetwork,
  partnerForkmzNetwork,
  citiesKmz,
  regionsKmz,
  geoServerResponseLinks,
  geoServerResponseSites,
  partnerOrRoute,
  allFetchedRoutes,
  selectedKmz,
} from '../../common/atom/atoms';
import CrossIcon from '../../Assets/AlertIcon/crossIcon.svg';
import UploadKmzModal from '../Kmz/upload_kmz_modal.component';
import KmzMapComponent from '../Kmz/kmz_map.component';
import { getAllKmzsWithFilters } from '../Kmz/functions/get_all_kmz_with_filters.function';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import { getAllRegions } from '../Kmz/functions/get_all_regions_kmz.function';
import { getAllCities } from '../Kmz/functions/get_all_cities.function';
import { LockedRouteLeftBarComponent } from '../Kmz/locked_routes_left_bar.component';
import { getRoutesForPoc } from '../Poc/functions/get_routes_for_poc.function';
import RingPlanningMap from './ring_planning_map_component';
import { RingRoutesListComponent } from './ring_routes_list.component';
import { getAllRingGroups } from './functions/get_all_ring_groups.function';
import { getOneRingGroup } from './functions/get_one_ring_group.function';
import { openCostModal, mapMarkersOnSelectedRoute } from '../../common/atom/atoms';
import Swal from 'sweetalert2';
const RingPlanningMain = () => {
  const [value, setValue] = useState(1);
  const [tabValue, setTabValue] = useState();
  const [allKmzData, setKmzData] = useAtom(allKmzs);
  const [partnerOrRouteValue, setPartnerOrRouteValue] = useAtom(partnerOrRoute);
  const [ringBar, setRingBar] = useAtom(openKmzBar);
  const [allRingGroups, setAllRingGroups] = useState([]);
  const [selectedRingId, setSelectedRingId] = useState(null);
  const [selectedRingRoutes, setSelectedRingRoutes] = useState([]);
  const [loadingRingId, setLoadingRingId] = useState(null);
  const [loadingRingGroups, setLoadingRingGroups] = useState(false);
  const [openCost, setOpenCost] = useAtom(openCostModal);
  const mapMarkersValue = useAtomValue(mapMarkersOnSelectedRoute);
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const kmzNetworks = useAtomValue(kmzNetwork);
  const kmzPartner = useAtomValue(partnerForkmzNetwork);
  const regionkmz = useAtomValue(regionForkmzNetwork);
  const citykmz = useAtomValue(cityForkmzNetwork);
  const setOpenUploadKmz = useSetAtom(openUploadKmz);
  const setGeoServerResponseSites = useSetAtom(geoServerResponseSites);
  const setAllFetchedRoutes = useSetAtom(allFetchedRoutes);
  const setGeoServerResponseLinks = useSetAtom(geoServerResponseLinks);
  const setCities = useSetAtom(citiesKmz);
  const setRegions = useSetAtom(regionsKmz);
  const setSelectedKmz = useSetAtom(selectedKmz);
  const navigate = useNavigate();
  const permissionsJSON = localStorage.getItem('permissions');

  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];
  const [controllerTab, setControllerTab] = useState(Generals.user);

  const fetchRingGroups = async () => {
    try {
      setLoadingRingGroups(true);
      const data = await getAllRingGroups();
      setAllRingGroups(data);
    } catch (error) {
      console.error('Error fetching ring groups:', error);
    } finally {
      setLoadingRingGroups(false);
    }
  };

  useEffect(() => {
    // Check if none of the required permissions are present
    if (!permissionNames.includes('Partner Network')) {
      navigate('/rov');
      return;
    }
    // Fetch ring groups when module loads
    fetchRingGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleRingSelect = async (ringId) => {
    if (ringId === null) {
      setSelectedRingId(null);
      setSelectedRingRoutes([]);
      setLoadingRingId(null);
      return;
    }

    try {
      setLoadingRingId(ringId);
      setSelectedRingId(ringId);
      const ringData = await getOneRingGroup(ringId);
      setSelectedRingRoutes(ringData);
      // Loading state will be cleared when zoom animation completes
    } catch (error) {
      console.error('Error fetching ring data:', error);
      setSelectedRingId(null);
      setSelectedRingRoutes([]);
      setLoadingRingId(null);
    }
  };

  const handleRingZoomComplete = () => {
    setLoadingRingId(null);
  };
  const handleChange = (event, tabName) => {
    setValue(Number(event.target.value));
    setControllerTab(tabName);
  };
  const handleTabSelection = (tabValue) => {
    setTabValue(tabValue);
    sessionStorage.setItem('selectedTab', tabValue);
    navigate('/fibers');
  };
  const handleOpenUploadModal = () => {
    setSelectedKmz(null);
    setOpenUploadKmz(true);
  };

  const handleAddCost = (ring) => {
    if (mapMarkersValue.length > 1) {
      // We need to pass the ring cost modal state to the map component
      // For now, we'll use the regular cost modal but with ring-specific logic
      setOpenCost(true);
    } else {
      Swal.fire({
        title: 'Select Ring First',
        text: `For adding "Cost" first select area between route`,
        icon: 'info',
        width: '300px',
        height: '300',
        customClass: {
          popup: 'small-swal',
        },
      });
      return;
    }
  };

  const handleEdit = (ring) => {
    // TODO: Implement edit functionality
    console.log('Edit ring:', ring);
  };

  const handleAudit = (ring) => {
    // TODO: Implement audit log functionality
    console.log('Audit log for ring:', ring);
  };

  const handleExport = async (ring, format) => {
    try {
      // Get ring routes data
      const ringData = await getOneRingGroup(ring.id);

      let response;
      let blob;
      let filename;

      if (format === 'geojson') {
        // Convert routes to GeoJSON format
        const geoJsonData = {
          type: 'FeatureCollection',
          features: ringData.map((route, index) => ({
            type: 'Feature',
            properties: {
              id: route.id,
              name: route.name || `Route ${index + 1}`,
              ringId: ring.id,
              ringName: ring.name,
            },
            geometry: route.geometry || {
              type: 'LineString',
              coordinates: [],
            },
          })),
        };

        response = JSON.stringify(geoJsonData, null, 2);
        blob = new Blob([response], { type: 'application/geo+json' });
        filename = `ring_${ring.id}_${ring.name.replace(/\s+/g, '_')}.geojson`;
      } else if (format === 'kmz') {
        // For KMZ, we'll create a simple KML structure
        const kmlData = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>${ring.name}</name>
    <description>Ring Group: ${ring.name}</description>
    ${ringData
      .map(
        (route, index) => `
    <Placemark>
      <name>${route.name || `Route ${index + 1}`}</name>
      <description>Route ${index + 1} of Ring Group: ${ring.name}</description>
      <LineString>
        <coordinates>${route.geometry?.coordinates?.map((coord) => `${coord[0]},${coord[1]}`).join(' ') || ''}</coordinates>
      </LineString>
    </Placemark>`
      )
      .join('')}
  </Document>
</kml>`;

        response = kmlData;
        const uint8Array = new TextEncoder().encode(response);
        blob = new Blob([uint8Array], { type: 'application/vnd.google-earth.kmz' });
        filename = `ring_${ring.id}_${ring.name.replace(/\s+/g, '_')}.kmz`;
      } else {
        console.error('Unsupported format');
        return;
      }

      // Download the file
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
      throw error;
    }
  };

  return (
    <>
      <DashboardLayout>
        <Box sx={{ flexGrow: 1, p: 0 }}>
          <Grid container spacing={0}>
            {ringBar !== true && (
              <Grid item xs={11.5}>
                <Box
                  sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '4%',
                    zIndex: 999,
                    cursor: 'pointer',
                  }}
                  onClick={() => setRingBar(true)}
                >
                  <img alt="" src={expandButton} style={{ width: '43px', height: '152px' }} />
                </Box>
              </Grid>
            )}

            {ringBar && (
              <Grid
                className={`alert_notification_grid ${ringBar ? 'open_alert_drawer' : 'close_alert_drawer'} `}
              >
                <div className="alerts_main" style={{ marginLeft: 0 }}>
                  <button className="crossButton" onClick={() => setRingBar((prev) => !prev)}>
                    <img alt="cross icon" src={CrossIcon} />
                  </button>
                  <RingRoutesListComponent
                    allRingGroups={allRingGroups}
                    onRingSelect={handleRingSelect}
                    selectedRingId={selectedRingId}
                    loadingRingId={loadingRingId}
                    loadingRingGroups={loadingRingGroups}
                    onRefresh={fetchRingGroups}
                    onAddCost={handleAddCost}
                    onEdit={handleEdit}
                    onAudit={handleAudit}
                    onExport={handleExport}
                  />
                </div>
              </Grid>
            )}
            <div
              className={`alert_notification_grid ${ringBar ? 'open_alert_content' : 'close_alert_content'} `}
            >
              <RingPlanningMap
                // getAllKmz={getAllKmz}
                getAllRoutes={fetchRingGroups}
                setKmzData={setKmzData}
                filters={{
                  regionsArray: regionkmz ? [regionkmz] : [],
                  citiesArray: citykmz ? [citykmz] : [],
                  kmzNetworks,
                  kmzPartner,
                }}
                selectedRingRoutes={selectedRingRoutes}
                selectedRingId={selectedRingId}
                onRingZoomComplete={handleRingZoomComplete}
              />
            </div>
          </Grid>
        </Box>
      </DashboardLayout>
    </>
  );
};

export default RingPlanningMain;
